import { DeliveryModes, PractitionerTypes, FacilityTypes } from './schema'

export const medicationAdministrationServices = [
  {
    serviceId: 'MED_001',
    serviceName: 'Intramuscular Injection',
    category: 'Medication Administration',
    specialty: null,
    subCategory: 'Injections',
    description: 'Administration of medications via intramuscular injection',
    cost: 80,
    durationMinutes: 10,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'MED_IM_INJ',
    billableItems: [
      {
        itemId: 'INJ_001',
        itemName: 'Syringe and needle',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL, FacilityTypes.PHARMACY],
    customisable: true,
    tags: ['injection', 'medication', 'intramuscular'],
    displayOrder: 1
  },
  {
    serviceId: 'MED_002',
    serviceName: 'Nebulization Treatment',
    category: 'Medication Administration',
    specialty: null,
    subCategory: 'Respiratory Treatment',
    description: 'Nebulizer treatment for respiratory conditions',
    cost: 120,
    durationMinutes: 20,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'MED_NEBULIZE',
    billableItems: [
      {
        itemId: 'NEB_001',
        itemName: 'Nebulizer medication',
        itemType: 'medication'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['nebulizer', 'respiratory', 'breathing'],
    displayOrder: 2
  },
  {
    serviceId: 'MED_003',
    serviceName: 'Chronic Medication Management',
    category: 'Medication Administration',
    specialty: null,
    subCategory: 'Chronic Care',
    description: 'Management and administration of chronic medications',
    cost: 150,
    durationMinutes: 30,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT, DeliveryModes.VIRTUAL],
    requiredPractitionerType: PractitionerTypes.PHARMACIST,
    status: 'active',
    billingCode: 'MED_CHRONIC',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.PHARMACY],
    customisable: true,
    tags: ['chronic', 'medication', 'management'],
    displayOrder: 3
  },
  {
    serviceId: 'MED_004',
    serviceName: 'Subcutaneous Injection',
    category: 'Medication Administration',
    specialty: null,
    subCategory: 'Injections',
    description: 'Administration of medications via subcutaneous injection',
    cost: 70,
    durationMinutes: 10,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'MED_SC_INJ',
    billableItems: [
      {
        itemId: 'INJ_002',
        itemName: 'Insulin syringe',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL, FacilityTypes.PHARMACY],
    customisable: true,
    tags: ['injection', 'subcutaneous', 'insulin'],
    displayOrder: 4
  },
  {
    serviceId: 'MED_005',
    serviceName: 'Pain Management Injection',
    category: 'Medication Administration',
    specialty: 'Pain Medicine',
    subCategory: 'Pain Relief',
    description: 'Therapeutic injection for pain management and relief',
    cost: 200,
    durationMinutes: 15,
    deliveryModes: [DeliveryModes.IN_PERSON],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'MED_PAIN_INJ',
    billableItems: [
      {
        itemId: 'PAIN_001',
        itemName: 'Pain medication injection',
        itemType: 'medication'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['pain', 'injection', 'management'],
    displayOrder: 5
  },
  {
    serviceId: 'MED_006',
    serviceName: 'Emergency Medication Administration',
    category: 'Medication Administration',
    specialty: null,
    subCategory: 'Emergency Care',
    description: 'Emergency administration of life-saving medications',
    cost: 300,
    durationMinutes: 15,
    deliveryModes: [DeliveryModes.IN_PERSON],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'MED_EMERGENCY',
    billableItems: [
      {
        itemId: 'EMERG_001',
        itemName: 'Emergency medication',
        itemType: 'medication'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.HOSPITAL],
    customisable: true,
    tags: ['emergency', 'medication', 'life-saving'],
    displayOrder: 6
  }
]

export default medicationAdministrationServices
